import {ExclamationIcon} from '@primer/octicons-react'
import {mergeabilityStatus, Status} from '@github-ui/mergebox/helpers/mergeability-status'
import {ForYouItem} from '../shared/ForYouItem'
import {useMergeabilityData} from './use-mergeability-data'
import {OverviewMergeControl} from './shared/OverviewMergeControl'
import {OverviewUpdateBranchControl} from './shared/OverviewUpdateBranchControl'
import {isForYouRefreshEnabled} from '../shared/for-you-feature-flags'
import {useForYouActionErrors} from '../shared/use-for-you-action-errors'

export function shouldShowAbleToMerge(
  data: ReturnType<typeof useMergeabilityData>,
): data is NonNullable<ReturnType<typeof useMergeabilityData>> {
  if (!data) return false

  const {mergeBoxPullRequest, mergeRequirements, statusChecksData} = data
  const status = mergeabilityStatus({
    pullRequest: mergeBoxPullRequest,
    mergeRequirements,
    statusChecksData,
  })
  const mergeRequirementsSatisfied =
    mergeRequirements?.state === 'MERGEABLE' || mergeRequirements?.state === 'MERGEABLE_IF_STATUSES_PASS'

  return mergeRequirementsSatisfied && status === Status.NonRequiredChecksUnsuccessful
}

export function AbleToMerge() {
  const {onUpdateBranchError, onQueueError, footer} = useForYouActionErrors()
  const data = useMergeabilityData()

  if (!shouldShowAbleToMerge(data)) return null

  return (
    <ForYouItem
      itemId="able-to-merge"
      footer={footer}
      visual={{kind: 'icon', icon: ExclamationIcon, tone: 'attention', glyphSize: 12}}
      title="Checks failing"
      subText="Some non-required checks are failing"
      actions={[
        {
          id: 'update-branch',
          content: isForYouRefreshEnabled() ? (
            <OverviewUpdateBranchControl itemName="able-to-merge" onError={onUpdateBranchError} />
          ) : null,
        },
        {
          id: 'merge-control',
          content: <OverviewMergeControl data={data} itemName="able-to-merge" onQueueError={onQueueError} />,
        },
      ]}
    />
  )
}
